var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewer-container",staticClass:"d-flex justify-content-center align-items-center",attrs:{"id":"viewer-loading"}},[_c('img',{attrs:{"src":require("@/assets/img/loading/load-grayscale.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }